import { useTranslation } from 'react-i18next'

export const FullyBookedBadge = ({
    fullyBooked,
    className = '',
}: {
    fullyBooked: boolean | undefined
    className?: string
}) => {
    const { t } = useTranslation()

    if (!fullyBooked) return null

    return (
        <span
            className={`rounded-full bg-brand-gray px-3 py-1.5 text-[11px] font-bold uppercase tracking-wider text-white shadow-sm ${className}`}
        >
            {t('frontend.events.fullyBooked')}
        </span>
    )
}
